<template lang="pug">
    div.TwoColumns1
        lessonHeader
        stepTitle
        v-layout(row wrap)
            v-flex(xs6)
                div.TwoColumns1-text 
                    | {{currentStep.text}}
            v-flex.TwoColumns1-image-container(xs6)
                div.TwoColumns1-image 
                    imageLoader
        buttonNext
        lessonFooter
</template>
<script>
import { mapGetters } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import imageLoader from "@/components/image-loader/image-loader";
import buttonNext from '@/components/button-next/button-next'

export default {
  name: 'TwoColumns1',
  components:{
	lessonHeader,    
	stepTitle,           
    lessonFooter,
    imageLoader,
    buttonNext        
  }, 
  computed: {
      ...mapGetters(['currentStep'])
  },
  methods: {    
  }
}
</script>

<style scoped>
    @import 'two-columns-1.scss';
</style>

